import React, { Component } from 'react';

class Logo extends Component {
  render() {
    return (

      <div class="logo-square">

      <svg viewBox="0 0 44 43" xmlns="http://www.w3.org/2000/svg" fillRule="evenodd"
      clipRule="evenodd" strokeLinejoin="round" strokeMiterlimit="1.414">
          <g id="logo">
              <path id="blue-9" fill="#36a0ce" d="M31 29.5h12.88v12.748H31z" />
              <path id="grey-9" fill="#cfcfcf" d="M31 29.5h12.88v12.748H31z" />
              <path id="blue-8" fill="#36a0ce" d="M15.5 29.5h12.879v12.748H15.5z" />
              <path id="grey-8" fill="#cfcfcf" d="M15.5 29.5h12.879v12.748H15.5z" />
              <path id="blue-7" fill="#36a0ce" d="M0 29.5h12.879v12.748H0z" />
              <path id="grey-7" fill="#cfcfcf" d="M0 29.5h12.879v12.748H0z" />
              <path id="blue-6" fill="#36a0ce" d="M31 14.5h12.88v12.748H31z" />
              <path id="grey-6" fill="#cfcfcf" d="M31 14.5h12.88v12.748H31z" />
              <path id="blue-5" fill="#36a0ce" d="M15.5 14.5h12.879v12.748H15.5z" />
              <path id="grey-5" fill="#cfcfcf" d="M15.5 14.5h12.879v12.748H15.5z" />
              <path id="blue-4" fill="#36a0ce" d="M0 14.5h12.879v12.748H0z" />
              <path id="grey-4" fill="#cfcfcf" d="M0 14.5h12.879v12.748H0z" />
              <path id="blue-3" fill="#36a0ce" d="M31 0h12.88v12.748H31z" />
              <path id="grey-3" fill="#cfcfcf" d="M31 0h12.88v12.748H31z" />
              <path id="blue-2" fill="#36a0ce" d="M15.5 0h12.879v12.748H15.5z" />
              <path id="grey-2" fill="#cfcfcf" d="M15.5 0h12.879v12.748H15.5z" />
              <path id="blue-1" fill="#36a0ce" d="M0 0h12.879v12.748H0z" />
              <path id="grey-1" fill="#cfcfcf" d="M0 0h12.879v12.748H0z" />
          </g>
      </svg>

      </div>

    );
  }
}

export default Logo;



// WEBPACK FOOTER //
// ./src/assets/components/icons/Logo.js